import React, { useCallback } from 'react'
import classNames from 'classnames'
import { DonateButtonProps } from './types'
import { GtmHelper } from 'shared'
import { StatusMessageBox } from 'ppp/status_message_box'

export const DonateButton = ({
  size,
  block,
  status,
  donateUrl,
  progressPercentage,
  projectId,
  projectTitle,
  carrierId,
  carrierName,
  carrierBlocked,
}: DonateButtonProps): JSX.Element | null => {
  const tracking = useCallback(() => {
    // TODO check if pushing "default values" aka null project is perhaps intended and the following guard is invalid
    if (!projectId) return
    GtmHelper.pushAddToBasket({ id: projectId, title: projectTitle, carrier: { name: carrierName, id: carrierId } })
  }, [projectId, projectTitle, carrierId, carrierName])

  if (status === 'preparing')
    return (
      <StatusMessageBox variant="info" dashed data-testid="ppp-donate-button">
        {i18n.t('projects.show.stats.donate_button_placeholder')}
      </StatusMessageBox>
    )

  if (status === 'blocked')
    return (
      <StatusMessageBox variant="warning" data-testid="ppp-donate-button">
        {i18n.t('projects.show.stats.donate_button_blocked_explanation')}
      </StatusMessageBox>
    )

  if (progressPercentage >= 100)
    return (
      <StatusMessageBox variant="success" centered data-testid="ppp-donate-button">
        {i18n.t('projects.show.stats.completed_label')}
      </StatusMessageBox>
    )

  if (status === 'closed')
    // (and not fully financed, see above)
    return (
      <StatusMessageBox variant="warning" data-testid="ppp-donate-button">
        {i18n.t('projects.show.stats.donate_button_closed_explanation')}
      </StatusMessageBox>
    )

  if (carrierBlocked)
    return (
      <StatusMessageBox variant="warning" data-testid="ppp-donate-button">
        {i18n.t('projects.show.stats.donate_button_blocked_explanation')}
      </StatusMessageBox>
    )

  const classes = classNames('btn', 'btn-primary', {
    'btn-block': block,
    'btn-large': size === 'large',
    'btn-huge': size === 'huge',
  })

  return (
    <a className={classes} data-testid="ppp-donate-button" href={donateUrl} onClick={tracking}>
      {i18n.t('projects.show.stats.donate_button_label')}
    </a>
  )
}
